import { graphql } from '@/gql';
import type { AssignTeamLeadMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const assignTeamLead = async ({ teamLeadSlackId, operatorSlackIds }: AssignTeamLeadMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation AssignTeamLead($teamLeadSlackId: String!, $operatorSlackIds: [String!]!) {
        assignTeamLead(teamLeadSlackId: $teamLeadSlackId, operatorSlackIds: $operatorSlackIds)
      }
    `),
    variables: {
      teamLeadSlackId,
      operatorSlackIds,
    },
  });

  return response.data?.assignTeamLead ?? false;
};
